import React, { useState } from 'react';
import { Button } from '../ui/button'; // Assuming you have a custom Button component
import DonationCard from './DonationCard'; // Import the DonationCard component
import { hooks } from 'botframework-webchat-component';

const { usePostActivity } = hooks;

const PaymentMethodCard = ({ cardData }) => {
  const [formData, setFormData] = useState({});
  const [selectedMethod, setSelectedMethod] = useState('');
  const [selectedBank, setSelectedBank] = useState('');
  const [showNetbankingOptions, setShowNetbankingOptions] = useState(false);
  const [donationAmount, setDonationAmount] = useState(null); // State to track selected donation amount

  const submitActivity = usePostActivity();

  // Handle form data input changes
  const handleInputChange = (id, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [id]: value,
    }));
  };

  // Handles donation selection
  const handleDonationSelection = (amount) => {
   
    setDonationAmount(amount); // Set the selected donation amount
  };

  // Handles form submit actions for payment methods
  const handleAction = (element, actionType) => {
    if (actionType === 'Submit' && element.data["type"] === "paymentMethod") {
      // Handle payment submission event with formData
      submitActivity({
        type: 'event',
        name: 'paymentChoiceEvent',
        value: { paymentMethod: element.data["paymentMethod"], ...formData },
        channelId: 'webchat',
      });
    }
  };

  // Handles payment method selection
  const handlePaymentSubmit = (paymentMethod) => {
    handleAction({ data: { type: 'paymentMethod', paymentMethod } }, 'Submit');
  };

  // Reset selection to go back to the list of payment methods
  const resetSelection = () => {
    setSelectedMethod('');
    setSelectedBank('');
    setShowNetbankingOptions(false);
    // setDonationAmount(null); // Reset donation amount
  };

  // Styles for buttons
  const buttonStyle = {
    display: 'block',
    margin: '8px 0',
    width: '100%',
    padding: '10px',
    backgroundColor: '#007560',
    color: '#fff',
    border: 'none',
    borderRadius: '8px',
    cursor: 'pointer',
    fontSize: '16px',
  };

  const backButtonStyle = {
    ...buttonStyle,
    backgroundColor: '#ccc', // Light grey for "Back to Payment Methods" button
    color: '#000',
  };

  return (
    <div style={{ padding: '16px', border: '1px solid #ddd', borderRadius: '8px' }}>
       
        {/* // Show Payment Method Card after donation selection */}
        <>
         {!selectedMethod?
          <h2 style={{ fontWeight: 'bold', fontSize: '16px' }}>Choose your payment method:</h2>
          :
          <h2 style={{ fontWeight: 'bold', fontSize: '16px' }}>{}</h2>

         }
          
          {/* Conditionally render payment methods or selected method details */}
          {!selectedMethod && (
            <div>
              {/* Credit/Debit Card Button */}
              <Button
                style={buttonStyle}
                onClick={() => setSelectedMethod('CreditDebitCard')}
              >
                Credit/Debit Card
              </Button>

              {/* Netbanking Button */}
              <Button
                style={buttonStyle}
                onClick={() => setSelectedMethod('Netbanking')}
              >
                Netbanking
              </Button>

              {/* Nuquodi A Button */}
              <Button
                style={buttonStyle}
                onClick={() => setSelectedMethod('NuquodiA')}
              >
                Noqodi Net banking
              </Button>

              {/* Nuquodi B Button */}
              <Button
                style={buttonStyle}
                onClick={() => setSelectedMethod('NuquodiB')}
              >
                Noqodi e-Wallet
              </Button>
            </div>
          )}

          {/* Credit/Debit Card Form */}
          {selectedMethod === 'CreditDebitCard' && (
  <div style={{ padding: '16px', border: '1px solid #ccc', borderRadius: '8px', marginBottom: '16px' }}>
   <div>
    
    <h3 style={{ fontWeight: 'bold', fontSize: '14px', marginBottom: '8px' }}>Enter Credit/Debit Card Details</h3>
    
    <input
      type="text"
      placeholder="Cardholder Name"
      style={{ width: '100%', padding: '10px', marginBottom: '16px', borderRadius: '4px', border: '1px solid #ccc' }}
    />

    <input
      type="text"
      placeholder="Card Number"
      maxLength="16"
      style={{ width: '100%', padding: '10px', marginBottom: '16px', borderRadius: '4px', border: '1px solid #ccc' }}
    />

    <div style={{ display: 'flex', gap: '16px', marginBottom: '16px' }}>
      <input
        type="text"
        placeholder="MM/YY"
        maxLength="5"
        style={{width:'60%', flex: '1', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
      />
      <input
        type="text"
        placeholder="CVV"
        maxLength="2"
        style={{width:'40%', flex: '1', padding: '10px', borderRadius: '4px', border: '1px solid #ccc' }}
      />
      </div>
    </div>
    <Button style={backButtonStyle} onClick={resetSelection}>
      Back to Payment Methods
    </Button>

    <Button style={buttonStyle} onClick={() => handlePaymentSubmit('CreditDebitCard')}>
      Submit Payment
    </Button>
  </div>
)}

          {/* Netbanking Form */}
          {selectedMethod === 'Netbanking' && (
            <div>
              <h3 style={{ fontWeight: 'bold', fontSize: '14px' }}>Select your bank:</h3>
              <select
                style={{ width: '100%', padding: '8px', marginBottom: '16px' }}
                onChange={(e) => setSelectedBank(e.target.value)}
              >
                <option value="">-- Select Bank --</option>
                <option value="AbuDhabiCommercialBank">Abu Dhabi Commercial Bank</option>
                <option value="AbuDhabiIslamicBank">Abu Dhabi Islamic Bank</option>
                <option value="AjmanBank">Ajman Bank</option>
                <option value="AlMasrafBank">Al Masraf Bank</option>
                <option value="ArabBank">Arab Bank</option>
                <option value="CitiBank">Citi Bank</option>
                <option value="CommercialBankOfDubai">Commercial Bank of Dubai</option>
                <option value="DubaiIslamicBank">Dubai Islamic Bank</option>
                <option value="EmiratesNBD">Emirates NBD</option>
                <option value="EmiratesIslamicBank">Emirates Islamic Bank</option>
                <option value="FirstAbuDhabiBank">First Abu Dhabi Bank</option>
                <option value="HabibBankAGZurich">Habib Bank A.G.Zurich</option>
                <option value="HilalBank">Hilal Bank</option>
                <option value="HSBCDXB">HSBC - DXB</option>
                <option value="MashreqBank">Mashreq Bank</option>
                <option value="NationalBankOfFujairah">National Bank of Fujairah</option>
                <option value="NationalBankOfUmmAlQuwain">National Bank of Umm Al Quwain</option>
                <option value="RAKBank">RAK Bank</option>
                <option value="SharjahIslamicBank">Sharjah Islamic Bank</option>
                <option value="StandardCharteredBank">Standard Chartered Bank</option>
                <option value="UnitedArabBank">United Arab Bank</option>
              </select>
              <Button
                style={buttonStyle}
                onClick={() => handlePaymentSubmit('Netbanking')}
              >
                Submit Payment
              </Button>
              <Button style={backButtonStyle} onClick={resetSelection}>
                Back to Payment Methods
              </Button>
            </div>
          )}

          {/* Nuquodi A */}
          {selectedMethod === 'NuquodiA' && (
            <div>
              <h3 style={{ fontWeight: 'bold', fontSize: '14px' }}>Nuquodi A payment method selected.</h3>
              <Button
                style={buttonStyle}
                onClick={() => handlePaymentSubmit('NuquodiA')}
              >
                Submit Payment
              </Button>
              <Button style={backButtonStyle} onClick={resetSelection}>
                Back to Payment Methods
              </Button>
            </div>
          )}

          {/* Nuquodi B */}
          {selectedMethod === 'NuquodiB' && (
            <div>
              <h3 style={{ fontWeight: 'bold', fontSize: '14px' }}>Nuquodi B payment method selected.</h3>
              <Button
                style={buttonStyle}
                onClick={() => handlePaymentSubmit('NuquodiB')}
              >
                Submit Payment
              </Button>
              <Button style={backButtonStyle} onClick={resetSelection}>
                Back to Payment Methods
              </Button>
            </div>
          )}
        </>
      
    </div>
  );
};

export default PaymentMethodCard;
